import { RQ, validateStock, isIOS, parseURL, getStatus, getTimeOffset } from 'utils';
import { cloneDeep, isEmpty } from 'lodash';
import { share } from 'utils/wx';
import { addClickAnalytics } from 'utils/analytics';
import moment from 'dayjs';

export default {
  getTipInfo: async function () {
    if (G.member && G.member.token) {
      const res = await RQ.mall.get('/api/h5/user/member/tips', {}, { skipAuth: true });
      if (res && res.code == 0) {
        this.tipInfo = res.data;
        // window.localStorage.setItem('tipInfo', JSON.stringify(res.data));
      } else {
        this.tips(res.msg, 1500);
      }
    }

  },
  getMemberInfo: async function () {
    const res = await RQ.mall.get('/api/app/member/getMemberSet', {
      cache: 'local',
      cacheTime: 15 * 60 * 1000,
      skipAuthHandle: true
    });

    if (res && res.code == 0) {
      this.MemberInfo = res.data;
    } else {
      this.tips(res.msg, 1500);
    }
  },
  getInfo: async function () {
    const res = await RQ.mall.get('/api/app/goodsApi/getGoodsDetail?t=' + Date.now(), {
      goodsId: this.params.goodsId
    });
    console.log('获取到商品数据 ', res);
    if (res && res.code == 0) {
      this.goods = res.data;
      this.activity = res.data.activity;
      this.pageTitle = res.data.goodsName;
      this.state = {
        goodsSpecs: res.data.goodsSpecs,
        selectedGoodsInfo: res.data.goodsInfo,
        buyNum: 1
      };
      this.startClocker(this.goods);
    } else {
      this.tips(res.msg, 1500);
    }
  },

  receiveCoupon: async function (couponId) {
    const d = await RQ.mall.post(
      '/api/h5/coupon/receiveCoupon',
      {
        couponId,
        position: 1
      }
    );
    if (d && d.code == 0) {
      console.log(self.goods, 'good');
      if (d.data.receiveStatus == 1) {
        // 领取状态（0：可以领取，1：已达领取上限）
        this.goods.coupons = this.goods.coupons.map(item => {
          if (item.couponId == couponId) {
            item.receiveStatus = 1;
          }
          return item;
        });
      }
      this.tips(d.msg);
    } else if (d.code == -3) {
      // 未开通超级会员
      this.isopen = false;
      this.showMn = true;
    } else {
      this.tips(d.msg);
    }
  },

  handleScroll(e) {
    this.throttleOnInfiniteScroll();
  },
  checkBottomReached() {
    return this.scrollEl.scrollTop + this.scrollEl.offsetHeight + 1 >= this.scrollEl.scrollHeight;
  },
  onInfiniteScroll() {
    if (this.checkBottomReached()) {
      if (this.activeTab == 1 && this.comments.items.length < this.comments.total) {
        this.getGoodsComments(this.comments.page + 1, this.tag);
      }
    }
  },
  changedComments: function (data) {
    this.comments = data;
  },

  getCommentCount: async function () {
    const res = await RQ.mall.get('/api/h5/goods/evaluation/count', { goodsId: this.params.goodsId });

    if (res && res.code == 0) {
      this.commentsTags = res.data;
      if (this.tag == undefined) {
        const all = res.data.labelList[0] || {};
        this.tag = all.label;
      }
    }
  },

  getGoodsComments: async function (page, tag) {
    if (page == 1) {
      this.getCommentCount();
    }
    if (this.comments.loading) return;
    this.comments.loading = true;
    console.log('page --', page, 'tag -- ', tag);
    const res = await RQ.mall.get('/api/h5/goods/evaluation/listExample', {
      goodsId: this.params.goodsId,
      label: tag,
      page,
      pageSize: 20
    });

    if (res.code == 0) {
      if (page <= 1) {
        this.comments = {
          items: res.data.pageData,
          page: res.data.page,
          total: res.data.total,
          loading: false
        };
      } else {
        this.comments = {
          items: (this.comments.items || []).concat(res.data.pageData),
          page: res.data.page,
          total: res.data.total,
          loading: false
        };
      }
    } else {
      this.comments = {
        items: this.comments.items,
        page: this.comments.page,
        total: this.comments.total,
        loading: false
      };
    }
    return res;
  },

  selectTag: async function (page, tag) {
    this.tag = tag;
    await this.getGoodsComments(page, tag);
  },

  // 选择规格相关
  selectedGoodsInfo: async function ({ goodsId, specialId, goodsSpecs }) {
    return RQ.mall.post('/api/app/goodsApi/getGoodsInfoWithSpec', {
      goodsId,
      specialId,
      goodsSpecs
    }, { lazyLoading: 300, jsonBody: true });
  },
  handleSelectSpec: async function (layer, index) {
    const { goodsSpecs } = this.state;
    const newGoodsSpecs = this.selectSpec(goodsSpecs, layer, index);

    const res = await this.selectedGoodsInfo({
      goodsId: this.params.goodsId,
      specialId: this.params.specialId,
      goodsSpecs: Object.values(this.getSelectedSpec(newGoodsSpecs)).map(v => ({
        specId: v.specId,
        specName: v.specName,
        specDetailId: v.specDetailId,
        specDetailValue: v.specDetailValue
      }))
    });
    if (res.code == 0) {
      this.setState({
        goodsSpecs: res.data.goodsSpecs,
        selectedGoodsInfo: res.data.goodsInfo
      });
    } else {
      this.setState({
        goodsSpecs: goodsSpecs
      });
      this.tips(res.msg);
    }
  },

  selectSpec: function (goodsSpecs, layer, index) {
    const newGoodsSpecs = cloneDeep(goodsSpecs);
    const goodsSpecDetails = newGoodsSpecs[layer].goodsSpecDetails;
    goodsSpecDetails.forEach((v, i) => {
      if (i === index) {
        if (v.selectStatus === 1) {
          // 取消勾选
          v.selectStatus = 0;
        } else {
          v.selectStatus = 1;
        }
      } else {
        v.selectStatus = 0;
      }
    });
    this.setState({ goodsSpecs: newGoodsSpecs });
    return newGoodsSpecs;
  },

  getSelectedSpec: function (goodsSpecs) {
    const selectedSpec = {};
    goodsSpecs.forEach(v => {
      v.goodsSpecDetails.forEach(vv => {
        if (vv.selectStatus === 1) {
          vv.specId = v.specId;
          vv.specName = v.specName;
          selectedSpec[v.specId] = vv;
        }
      });
    });
    return selectedSpec;
  },

  minusBuyNum: function () {
    const buyNum = this.state.buyNum > 1 ? this.state.buyNum : 1;
    console.log('buyNum ---------> ', buyNum);
    this.setState({ buyNum });
  },

  plusBuyNum: function () {
    const buyNum = this.state.buyNum;
    console.log('buyNum ---------> ', buyNum);
    this.setState({ buyNum });
  },

  setBuyNum: function (text) {
    this.setState({ buyNum: validateStock(String(text)) });
  },

  checkValite: function (value) {
    if (value < 1) {
      // this.tips('数量超出范围');
      this.setState({ buyNum: 1 });
    }
  },

  checkBuyNumIsBeyond: function () {
    const { goodsInfo, selectedGoodsInfo, buyNum } = this.state;
    const { goodsStock } = goodsInfo.data || {};
    const { goodsInfoStock } = selectedGoodsInfo || {};
    const realGoodsStock = goodsInfoStock || goodsStock;
    if (buyNum > realGoodsStock) {
      this.tips(`库存不足，剩${realGoodsStock}件`);
      return true;
    }
    return false;
  },

  getSelectGoodsInfoId: function () {
    const { selectedGoodsInfo, goodsSpecs } = this.state;
    let goodsInfoId;
    // 需要选规格
    if (!isEmpty(goodsSpecs)) {
      if (isEmpty(selectedGoodsInfo)) {
        // return Toast.showShortCenter('请选择商品规格');
        this.tips('请选择商品规格');
        return;
      }
      goodsInfoId = selectedGoodsInfo.goodsInfoId;
    } else {
      goodsInfoId = selectedGoodsInfo.goodsInfoId;
    }
    return goodsInfoId;
  },

  setState: function (newState) {
    Object.keys(newState).forEach(v => {
      this.state[v] = newState[v];
    });
  },

  buy: async function () {
    if (G.member && G.member.token) {
      const { buyNum } = this.state;
      const goodsId = this.params.goodsId;
      const goodsInfoId = this.getSelectGoodsInfoId();
      const specialId = this.params.specialId;
      console.log('goodsInfoId: ', goodsInfoId, 'goodsId: ', goodsId);
      if (goodsId != undefined && goodsInfoId != undefined) {
        const res = await RQ.mall.post('/api/app/order/confirmOrder', {
          goodsInfoId, goodsNum: buyNum, specialId,
          isPlatform: G.is_platform !== undefined ? G.is_platform : 0
        }, {
          jsonBody: true
        });
        // const res = await RQ.mock.get('/api/app/order/confirmOrder');

        if (res.code == 0) {
          // TODO 临时使用localStorage页面传值，后边需修改掉
          window.localStorage.setItem('settlement', JSON.stringify(res.data));
          this.cancelClocker();
          this.$router.push({
            path: `/${G.enterprise}/cart/settlement`,
            query: {
              goodsInfoId: goodsInfoId,
              goodsNum: buyNum
            }
          });
        } else if (res.code == -5) {
          this.isopen = true;
          this.showMn = true;
        } else {
          this.tips(res.msg);
        }
      }
    } else {
      this.showLogin = true;
      // TODO login
    }
  },
  handleClickLogin() {
    this.cancelClocker();
    this.$router.push({
      path: '/login',
      query: {
        enterprise: this.params.enterprise,
        inviteCode: this.params.inviteCode,
        redirect: encodeURIComponent(location.href.replace(location.origin, ''))
      }
    });
  },
  confirmFn() {
    if (G.member && G.member.token) {
      // 登录注册了
      this.tipInfo.openType == 1 ? addClickAnalytics({ LogTitle: '立即开通' }) : addClickAnalytics({ LogTitle: '立即续费' });
      this.cancelClocker();
      this.$router.push('/vippay?enterprise=' + this.params.enterprise);
    } else {
      // 未登录注册
      addClickAnalytics({ LogTitle: '登录注册' });//
      this.handleClickLogin();
    }
  },
  cancelFn() {
    let self = this;
    self.showMn = false;
  },
  showCouponPop() {
    if (G.member && G.member.token) {
      this.showCoupons = true;
    } else {
      this.showLogin = true;// 未注册/登录弹窗;
      this.popContent = '需要登录注册后才能领券';
    }
  },
  addShare(goodsId, inviteCode) {
    // const res = {
    //   data : {
    //     shareUrl: 'http://test-leadmall-c.vipzhuang.cn/E201805221004237724/goods/514?inviteCode=2887770',
    //     shareTitle: '口红',
    //     shareImg: 'http://201442.image.myqcloud.com/201442/0/384e77f6-742b-4d6e-8e8a-2a89abe126a4/original',
    //     shareContent: '垃圾！！！ '
    //   }
    // }
    RQ.mall.get('/api/h5/goods/getGoodsShareInfo', {
      goodsId: goodsId,
      inviteCode: inviteCode
    }, {
      skipAuth: true,
      enterprise: G.enterprise || '00'
    }).then(res => {
      if (res && res.code == 0) {
        const shareData = res.data;
        share(this.$route, {
          title: shareData.shareTitle,
          desc: shareData.shareContent,
          link: shareData.shareUrl + `&is_platform=${G.is_platform !== undefined ? G.is_platform : 0}`,
          imgUrl: shareData.shareImg,
          type: 'link'
        });
      }
    });
  },
  startClocker(goodsInfo) {
    const activity = goodsInfo.activity;
    if (activity && activity.type === 1) {
      this.updateClocker(activity);
      this.__interval = setInterval(() => {
        this.updateClocker(activity);
      }, 1000);
    }
  },
  getActivityStatus(activity) {
    const status = getStatus(
      moment(activity.nowTime),
      moment(activity.startTime),
      moment(activity.endTime)
    );

    // 如果当前活动进行中并且已抢光或者已结束并有下一场，提醒下一次什么时候开始
    if (((status == 'ING' && activity.surplusStock <= 0) || status == 'DONE') && activity.nextTime) {
      return 'NEXT';
    } else {
      return status;
    }
  },
  updateClocker(activity) {
    const nowTime = new Date();
    // 如果当前时间与下一场时间一致，重新刷新页面
    if (activity.nextTime) {
      const nextTime = moment(activity.nextTime).toDate();
      // if(nowTime.getTime() == nextTime.getTime()) {
      if (moment(nowTime).format('YYYY-MM-DD HH:mm:ss') == moment(nextTime).format('YYYY-MM-DD HH:mm:ss')) {
        window.location.reload();
      }
    }

    this.activityStatus = this.getActivityStatus(activity);
    switch (this.activityStatus) {
      case 'WILL': {
        this.clockerFmt = getTimeOffset(moment(activity.startTime).toDate(), nowTime);
        break;
      }
      case 'ING': {
        this.clockerFmt = getTimeOffset(moment(activity.endTime).toDate(), nowTime);
        break;
      }
      case 'NEXT': {
        if (activity.nextTime) {
          this.clockerFmt = getTimeOffset(moment(activity.nextTime).toDate(), nowTime);
        } else {
          this.clockerFmt = undefined;
        }
        break;
      }
      case 'DONE': {
        this.cancelClocker();
        break;
      }
    }
  },
  cancelClocker() {
    if (this.__interval) {
      clearInterval(this.__interval);
    }
    this.clockerFmt = undefined;
  },
  timestampToTime(timestamp) {
    return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
  }
};



// WEBPACK FOOTER //
// ./src/module/goods/detail/action.js